import { NoEditPlugin } from '@src/slide/application/no-edit/plugins/no-edit-plugin';
import { IReadRecordPlugin } from '@src/slide/application/no-edit/plugins/read-record/read-record-plugin.interface';
import { ReadRecordRightBarModule, MODULE_NAME } from '@src/slide/application/no-edit/plugins/read-record/read-record-right-bar-module';
import NoEditArkLoader from '@src/slide/application/no-edit/common/no-edit-ark-extensions';
import { READ_RECORD_EXTENSION_CONFIG } from '@src/slide/application/no-edit/common/no-edit-ark-extensions/dc-components/read-record/component-config';
import { browser } from '@src/slide/application/service/edit-extension/edit-extension-export';
import { IExtension } from '@tencent/ark-extensions';
import { setNewWindowUrl } from '@tencent/tencent_doc_open_url';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { IBaseEditorExtensionService } from '@src/slide/application/service/edit-extension/core/editor/base/interface';
/**
 * 非编辑浏览记录plugin
 */
export default class ReadRecordPlugin extends NoEditPlugin implements IReadRecordPlugin {
    declare protected editExtensionService?: IBaseEditorExtensionService;
    private extension?: IExtension;

    public initPlugin(): void {
        this.editExtensionService?.registerRightSideBarModule(new ReadRecordRightBarModule(this));
    }

    public async showModule(DOMNode: Element | Text | null, onShow: () => void, onClose: () => void): Promise<void> {
        const { userId, domainId, padId, creatorDomain } = SlideDataServices.DocInfoManager() || { };
        const myUserId = userId?.replace(/^p\./, '');
        this.extension = await NoEditArkLoader.extensionService.getExtension(READ_RECORD_EXTENSION_CONFIG.name);
        this.extension.show({
            container: DOMNode,
            creatorDomain,
            domainId,
            padId,
            userId: myUserId,
            onClose: () => {
                onClose();
                if (this.editExtensionService?.isShowRightSideBar(MODULE_NAME)) {
                    this.editExtensionService?.hideRightSideBar();
                }
            },
        });
        onShow?.();
    }

    public removeModule(): void {
        this.extension?.hide();
        this.extension = undefined; // 移除时不再抓引用
    }

    public show(): void {
        this.editExtensionService?.showRightSideBar(MODULE_NAME);
    }

    public showOnMobile(): void {
        const { domainId, padId, creatorDomain } = SlideDataServices.DocInfoManager() || { };
        const query = `padId=${padId}&domId=${domainId}&cd=${creatorDomain}`;
        if (browser.isMiniProgram) {
            if (window.wx) {
                window.wx.miniProgram.navigateTo({
                    url: `/pages/readRecord/readRecord?${query}`,
                });
            }
        } else if (window.mqq) {
            window.mqq?.ui?.openUrl?.({
                url: `https://${window.hostname}/components/docs/ReadRecord.html?${query}&_wv=3&from=desktop_m`,
                target: 1,
                style: 1,
            });
        } else {  // 走H5页面
            const url = `https://${window.hostname}/components/docs/ReadRecord.html?${query}&_wv=3&from=desktop_m`;
            setNewWindowUrl(window, url);
        }
    }
}
